

























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component
export default class Event extends Vue {
    @Prop(Object) private item!: Connex.Thor.Event
    @Prop(Number) private index!: number

    private view = 'raw' as 'raw' | 'decoded'
    private decodedViewCreated = false
    @Watch('view')
    private viewChanged() {
        if (this.view === 'decoded') {
            this.decodedViewCreated = true
        }
    }
    get isDecodable() { return this.item.topics.length > 0 }
}
